<template>
  <div class="pdp-purchase-option-dropdown">
    <div class="pdp-purchase-option-dropdown-label">
      <h5 class="pdp-purchase-option-dropdown-title">
        {{ title }}
      </h5>
      <span class="pdp-purchase-option-dropdown-subtitle">
        {{ subtitle }}
      </span>
    </div>
    <div class="pdp-purchase-option-dropdown-select">
      <select v-model="currentValue">
        <option
          v-for="option in options"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
      <svg class="icon icon-cheveron-down">
        <use xlink:href="#icon-cheveron-down" />
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PurchaseOptionDropdown',

  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    currentValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        const value = parseInt(newVal);

        this.$emit('change', value);
      }
    }
  }
};
</script>
